import { useAuth } from '@app/core/auth/authentication/hooks/useAuth';
import { ListingView } from '@app/core/reports/components/ListingView';
import { apiClient } from '../../../../../../api';
import { ReportListFilterForm } from './ReportListFilter';
import { ReportsListView } from './ReportListView';
import { ReportListType } from './types';

export function ReportsListContainer() {
  const auth = useAuth();

  return (
    <ListingView<ReportListType>
      defaultValues={{
        showOther: false,
        pageIndex: 0,
        pageSize: 50,
      }}
      queryParamsTransform={{
        showOther: {
          parse: (input) => Boolean(input),
        },
      }}
      reportFn={async (values) => {
        return apiClient.reports.fetchReports({
          createdById: (values.showOther as boolean) === false ? auth.user.id : undefined,
          page: values.pageIndex,
          pageSize: values.pageSize,
        });
      }}
      Form={ReportListFilterForm}
      Result={ReportsListView}
    />
  );
}
